import React from 'react';

import AppComponent from './core/AppComponent';
import InsightsContainer from '../containers/InsightsContainer';
import CoreMetrics from '../containers/CoreMetrics';

import '../css/Clients.css';

class Metrics extends AppComponent {
  render() {
    return (
      <React.Fragment>
        <div className="text-left">
          <h2 className="nightingale-text">Core Metrics</h2>
          <CoreMetrics facilityId={this.props.facilityId} />
        </div>
        <hr />
        <div className="text-left">
          <h2 className="nightingale-text">Insights</h2>
          <InsightsContainer facilityId={this.props.facilityId} />
        </div>
      </React.Fragment>
    );
  }
}

export default Metrics;



// WEBPACK FOOTER //
// ./src/components/Metrics.js